import React, { Component } from 'react';
import PropTypes from "prop-types";

import Logo from "../Logo";

/**
 * A component used to display a full-screen error message.
 *
 * @usage;
 *
 *		import { ErrorMessage } from '../app'
 *
 *		...
 *		<ErrorMessage
 * 	 		code={401}
 * 	 		message="Sorry, you need to log in"
 * 	 	/>
 *		...
 *
 * @author Sam Sehnert <sam@customd.com>
 *
 * @type {Component}
 */
class ErrorMessage extends Component {
  /**
   * The properties that this component can use.
   * @type {Object}
   */
  static propTypes = {
    /**
     * The main title of the error message.
     */
    title: PropTypes.string,

    /**
     * An optional sub-message to display.
     * Typically used to explain an error in more detail, e.g.,
     * next steps, what went wrong, how to resolve, or what to expect.
     */
    message: PropTypes.string,

    /**
     * Should be a node, or an array of nodes.
     * This is content which might help the user
     * resolve the error, or guide toward resolution
     */
    children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),

    /**
     * This should be a function to run on retry click.
     */
    onRetry: PropTypes.func,
  };

  /**
   * Set the default values of properties.
   * @type {Object}
   */
  static defaultProps = {
    title: 'Sorry, an error occurred',
  };

  /**
   * Render the error message.
   *
   * @author Sam Sehnert <sam@customd.com>
   *
   * @return {React}  A react DOM node.
   */
  render() {
    const { title, message, children, onRetry } = this.props;

    return (
      <div className="donation_portal__main">
        <div className="panel panel--hero">
          <div className="panel__content">
            <a href="/" className="afes_logo">
              <Logo />
            </a>
            <h1 className="panel__heading">{title}</h1>
            {message && <h2>{message}</h2>}
            {children}
          </div>
          <div className="panel__foot">
            <div className="inline_buttons">
              <a href="/" className="btn_pri btn_pri--forward">
                Make a donation
              </a>
              <a href="http://www.afes.org.au/" target="_blank" className="btn_ter">
                Visit afes.org.au
              </a>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default ErrorMessage;
